import { render } from "./PackagesIlets.vue?vue&type=template&id=5a4af667&scoped=true"
import script from "./PackagesIlets.vue?vue&type=script&lang=js"
export * from "./PackagesIlets.vue?vue&type=script&lang=js"

import "./PackagesIlets.vue?vue&type=style&index=0&id=5a4af667&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4af667"]])

export default __exports__